import OutboundTransactionCommissionSummaryService
    from "../services/finance/OutboundTransactionCommissionSummaryService";
import ToastHelper from "../utils/ToastHelper";
import React, {Fragment} from "react"
import SFXLoadingComponent from "./SFXLoadingComponent";
import {Row} from "reactstrap";
import "../views/Commission/CommissionSummary.css";
import UserSessionService from "../services/UserSessionService";

export default class AgentCommissionSummaryComponent extends React.Component {

    constructor(props) {
        super(props);

        let agentId = UserSessionService.getUser().user.id;

        this.state = {
            commissionSummaryData: [],
            isLoading: true,
            agentId: agentId
        }

    };

    componentDidMount() {
        this.loadData();
    }

    loadData() {
        OutboundTransactionCommissionSummaryService.retrieve(this.state.agentId).then(response => {
            if (response["errors"]) {
                ToastHelper.formatError(response)
            } else {
                this.setState({
                    commissionSummaryData: response.body,
                    isLoading: false
                })
            }
        })
    }

    getCommissionMonthDisplayValue(month) {
        switch (month) {
            case 1:
                return "January"
            case 2:
                return "February"
            case 3:
                return "March"
            case 4:
                return "April"
            case 5:
                return "May"
            case 6:
                return "June"
            case 7:
                return "July"
            case 8:
                return "August"
            case 9:
                return "September"
            case 10:
                return "October"
            case 11:
                return "November"
            case 12:
                return "December"
            default:
                return "Unknown"
        }
    }

    addSpacesToAmountValues(amount){
        return amount.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    render() {
        let commissionSummaryData = this.state.commissionSummaryData;
        return <Fragment>
            {this.state.isLoading ? <SFXLoadingComponent/>
                :
                <Fragment>
                    {commissionSummaryData.map((item, index) => {
                        return <Fragment key={index}>
                            {this.renderSingleMonthSummary(item)}
                        </Fragment>
                    })
                    }
                </Fragment>
            }
        </Fragment>
    }

    renderSingleMonthSummary(item) {

        let negativeValueStyle = "";

        if(item.commissionPercentage < 0 || item.commissionRandAmount < 0){
            negativeValueStyle = "red";
        }

        return <Fragment>
            <div className={"commission_date_subheader"}>{item.year + " " + this.getCommissionMonthDisplayValue(item.month)}</div>
            <Row className={"commissionContent"}>
                <div className={"welcome_card"}>
                    <div className={"welcome_card_text"}>
                <span className={"welcome_card_header"}>
                    {"Number of Transactions"}<br/>
                </span>
                        <span className={"welcome_card_value"}>
                    {item.transactionCount}
                </span>
                    </div>
                </div>
                <div className={"welcome_card"}>
                    <div className={"welcome_card_text"}>
                <span className={"welcome_card_header"}>
                    {"Total Rand Amount"}<br/>
                </span>
                        <span className={"welcome_card_value"}>
                    {"R " + this.addSpacesToAmountValues(item.randCapitalAmount)}
                </span>
                    </div>
                </div>

                <div className={"welcome_card"}>
                    <div className={"welcome_card_text"}>
                <span className={"welcome_card_header"}>
                    {"Total Commission Amount"}<br/>
                </span>
                        <span className={"welcome_card_value"} style={{color: negativeValueStyle}}>
                    {"R " + this.addSpacesToAmountValues(item.commissionRandAmount)}
                </span>
                    </div>
                </div>
                <div className={"welcome_card"}>
                    <div className={"welcome_card_text"}>
                <span className={"welcome_card_header"}>
                    {"Commission Percentage"}<br/>
                </span>
                        <span className={"welcome_card_value"} style={{color: negativeValueStyle}}>
                    {(parseFloat(item.commissionPercentage) * 100).toFixed(2) + "%"}
                </span>
                    </div>
                </div>
            </Row>
            <hr/>
        </Fragment>
    }
}